import {
  MarketCapitalizationSection,
  ReturnSection,
  Section,
} from '@/components';
import Table from '@/components/molecules/Table/Table';
import NetworkListItem from '@/components/organisms/NetworkListItem/NetworkListItem';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces';
import {
  formatNumberToAmountInUsdString,
  formatNumberToAPYString,
} from '@/utils/formatUtils';
import { FC } from 'react';
interface UnderlyingYieldBearingAssetDetailTableProps {
  underlyingYieldBearingAsset: UnderlyingYieldBearingAssetInterface;
  showChips?: boolean;
  showSection?: boolean;
  showNetworkDetail?: boolean;
}
const UnderlyingYieldBearingAssetDetailTable: FC<
  UnderlyingYieldBearingAssetDetailTableProps
> = ({
  underlyingYieldBearingAsset,
  showChips = false,
  showSection = true,
  showNetworkDetail = false,
}) => {
  if (showChips) {
    return (
      <div className="grid grid-cols-2 gap-sm">
        <div className="flex items-stretch">
          <MarketCapitalizationSection asset={underlyingYieldBearingAsset} />
        </div>
        <div className="flex items-stretch">
          <ReturnSection asset={underlyingYieldBearingAsset} />
        </div>
      </div>
    );
  }
  const columnWidths = [50, 50];
  const rows = [
    {
      cells: [
        { mainText: 'Return' },
        {
          mainText: formatNumberToAPYString(underlyingYieldBearingAsset.apy),
          align: 'right' as 'right',
        },
      ],
    },
    {
      cells: [
        { mainText: 'Market Capitalization' },
        {
          mainText: formatNumberToAmountInUsdString(
            underlyingYieldBearingAsset.tvlUSD,
          ),
          align: 'right' as 'right',
        },
      ],
    },
    {
      cells: [
        { mainText: 'Composition' },
        {
          mainText: `${Math.round(
            underlyingYieldBearingAsset.composition * 100,
          )}%`,
          align: 'right' as 'right',
        },
      ],
    },
    ...(showNetworkDetail
      ? [
          {
            cells: [
              { mainText: 'Network' },
              {
                mainText: (
                  <NetworkListItem
                    blockchain={underlyingYieldBearingAsset.blockchain}
                    blockchainDisplayName={
                      underlyingYieldBearingAsset.blockchainDisplayName
                    }
                    align="right"
                  />
                ),
                align: 'right' as 'right',
              },
            ],
          },
        ]
      : []),
  ];
  const table = (
    <Table columnWidths={columnWidths} rows={rows} isAscending={true} />
  );
  return showSection ? <Section body={table} /> : table;
};
export default UnderlyingYieldBearingAssetDetailTable;
